import classNames from 'classnames';
import React, { useCallback } from 'react';

import AccessibleDiv from 'components/AccessibleDiv/AccessibleDiv';
import Icon from 'components/Icon';
import { AssetsCollectionNavIcons, AssetsCollectionNavItem, AssetsCollectionTooltipText } from 'const';
import { AssetsCollectionNavBarProps } from './models';
import styles from './styles.module.scss';

const AssetsCollectionNavBar: React.FunctionComponent<AssetsCollectionNavBarProps> = (props) => {
  const { navItems, disabledItems, activeItem, onChange } = props;

  const onItemChange = useCallback(
    (navItem: AssetsCollectionNavItem) => (): void => {
      onChange(navItem);
    },
    [onChange],
  );

  return (
    <div className={styles.AssetsNavBar}>
      {
        navItems.map((navItem) => {
          const isActive = activeItem === navItem;
          const isDisabled = disabledItems.includes(navItem);

          return (
            <AccessibleDiv
              key={navItem}
              className={classNames(
                styles.icon,
                {
                  [styles.active]: isActive,
                  [styles.disabled]: isDisabled,
                },
              )}
              onClick={isDisabled ? (): void => {} : onItemChange(navItem)}
              data-tooltip={AssetsCollectionTooltipText[navItem]()}
            >
              <Icon type={AssetsCollectionNavIcons[navItem]} size="sm" color={isActive ? 'secondary' : 'primary'} />
            </AccessibleDiv>
          );
        })
      }
    </div>
  );
};

export default AssetsCollectionNavBar;
